
import { TestCreatorHeader as Header } from "../TestCreatorHeader";
import { useAuth } from "@/contexts/AuthContext";

interface TestCreatorHeaderProps {
  testId: string | undefined;
  onBackClick?: () => void;
}

export const TestCreatorHeaderSection = ({ testId, onBackClick }: TestCreatorHeaderProps) => {
  const { user } = useAuth();
  
  return (
    <Header
      isEditing={!!testId}
      onBackClick={onBackClick}
    />
  );
};
